import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { SharedService } from "src/app/modules/gasprecio/services/shared.service";

@Component({
  selector: 'app-select-moda-variable',
  templateUrl: './select-moda-variable.component.html',
  styleUrls: ['./select-moda-variable.component.scss']
})
export class SelectModaVariableComponent implements OnInit, OnDestroy {
  public items: any[] = [
    { name: 'Moda Litros', value: 'liters' },
    { name: 'Moda Monto', value: 'amount' },
  ];
  private variableSelected$!: Subscription;
  public variableSelected: string = "liters";

  constructor(
    private sharedService: SharedService
  ) {
  }

  ngOnInit(): void {
    this.variableSelected$ = this.sharedService.sharedVariableMode.subscribe((variable) => {
      if (variable !== undefined) {
        this.variableSelected = variable;
      }
    });
  }

  ngOnDestroy(): void {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any): void {
    this.variableSelected = event;
    this.sharedService.nextVariableMode = this.variableSelected;
  }
}
